/* =====================================================================
   HL LONDON — PDP CORE JS (Phase 2A)
   Only job: drive the mobile sticky add-to-bag bar.

   Does NOT touch: the Selleasy block or its global embed, the
   cart-drawer window.fetch patch, king-linked-options, bf-size-charts,
   or reviews-io. The bar forwards clicks to the theme's real submit
   button so every one of those app integrations keeps its handlers.
   ===================================================================== */
(function () {
  'use strict';

  var MOBILE_MAX = 767.98;
  var bar, realBtn, form, titleEl, priceEl, barBtn;
  var atbObserver = null;
  var footObserver = null;
  var atbOutOfView = false;
  var footerVisible = false;
  var initTries = 0;

  function isMobile() {
    return window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)').matches;
  }

  /* Is this element actually on screen, as opposed to merely in the DOM?

     Deliberately NOT offsetParent: every overlay worth caring about here is
     position:fixed, and offsetParent is null for fixed elements whether
     they are shown or not. visibility / display / opacity are what these
     components actually animate. */
  function isShown(el) {
    if (!el) return false;
    var c = window.getComputedStyle(el);
    if (c.display === 'none' || c.visibility === 'hidden') return false;
    if (parseFloat(c.opacity) < 0.01) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  /* The drawer / modal shades set these on <body>; while any of them is up
     the bar must get out of the way rather than float over the overlay.

     PHASE 3 FIX: the selector test used to be presence-only, and that made
     the sticky bar dead on any PDP carrying a size chart. MEASURED on the
     fur PDP:

       div.scr-modal   (bf-size-charts)
         aria-modal="true", no [hidden] attribute
         display:block  visibility:hidden  opacity:0  position:fixed

     — i.e. present and closed. It matched, overlayOpen() returned true on
     every pass, and the bar never showed however far you scrolled. The
     boots PDP has no size chart, which is why the bar worked there and the
     fault looked product-specific rather than structural.

     A closed modal is not an open overlay, so the elements are now tested
     for being genuinely visible. */
  function overlayOpen() {
    var c = document.body.className;
    if (/reveal-mobile-nav|cart-drawer-open|drawer-open|cc-modal-open|show-modal|no-scroll/.test(c)) {
      return true;
    }
    var nodes = document.querySelectorAll('.cart-drawer.is-open, .cc-modal.is-open, [aria-modal="true"]:not([hidden])');
    for (var i = 0; i < nodes.length; i++) {
      if (isShown(nodes[i])) return true;
    }
    return false;
  }

  /* Every write below is guarded on "is it already that value?".
     These functions run FROM MutationObservers whose targets include the
     nodes they write to, so an unconditional assignment is an infinite
     loop that pegs the CPU and stalls DOMContentLoaded. Learned the hard
     way — do not "simplify" these back to plain assignments. */
  function setText(el, value) {
    if (el && el.textContent !== value) el.textContent = value;
  }

  function update() {
    if (!bar) return;
    var show = isMobile() && atbOutOfView && !footerVisible && !overlayOpen();
    if (bar.classList.contains('is-visible') !== show) {
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    if (document.body.classList.contains('pdp-sticky-on') !== show) {
      document.body.classList.toggle('pdp-sticky-on', show);
    }
  }

  /* Mirror the theme's live price + button state into the bar, so a variant
     change (including the ?variant= deep-link landing) stays truthful. */
  function sync() {
    if (!bar) return;

    var priceSrc = document.querySelector('.product-detail .price-area .current-price') ||
      document.querySelector('.product-detail .current-price') ||
      document.querySelector('.product-detail .price');
    if (priceSrc && priceEl) {
      var txt = priceSrc.textContent.replace(/\s+/g, ' ').trim();
      if (txt) setText(priceEl, txt);
    }

    /* PHASE 3 — the bar's top line is the shopper's own choice, read off
       the checked option inputs ("Ivory · Size 8"). Falls back to the
       app-rendered colour name when the colourway is a separate product
       and so has no Colour radio of its own. */
    if (titleEl) {
      var parts = [];
      var lvSel = document.querySelector('.product-detail .lv-option-item--selected, .product-detail .lv-option-item[aria-selected="true"], .product-detail .lv-option-item.is-selected');
      if (lvSel) {
        var lvName = (lvSel.getAttribute('title') || lvSel.getAttribute('data-value') ||
          lvSel.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim();
        if (lvName) parts.push(lvName);
      }
      var checked = document.querySelectorAll('.product-detail .option-selector .opt-btn:checked');
      for (var c = 0; c < checked.length; c++) {
        var sel = checked[c];
        var host = sel.closest ? sel.closest('.option-selector') : null;
        var oname = host ? (host.getAttribute('data-option-name') || '') : '';
        var val = (sel.value || '').replace(/\s+/g, ' ').trim();
        if (!val) continue;
        /* A size reads as "Size 8"; a colour reads as its own name. */
        parts.push(/size/i.test(oname) ? oname + ' ' + val : val);
      }
      setText(titleEl, parts.join(' · '));
    }

    /* Name the chosen swatch — a photo of a sleeve does not say "Sage". */
    var selLabels = document.querySelectorAll('.product-detail [data-selected-value-for]');
    for (var i = 0; i < selLabels.length; i++) {
      var idx = selLabels[i].getAttribute('data-selected-value-for');
      var sel = document.querySelector('.product-detail .option-selector[data-option-index="' + idx + '"] .opt-btn:checked');
      setText(selLabels[i], sel ? ' — ' + sel.value : '');
    }

    if (realBtn && barBtn) {
      var disabled = !!(realBtn.disabled || realBtn.getAttribute('aria-disabled') === 'true');
      if (barBtn.disabled !== disabled) barBtn.disabled = disabled;
      var label = (realBtn.textContent || '').replace(/\s+/g, ' ').trim();
      if (label) setText(barBtn, label);
    }
  }

  /* Coalesce observer bursts into one pass per frame. */
  var queued = false;
  function scheduleSync() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || window.setTimeout)(function () {
      queued = false;
      sync();
      update();
    }, 16);
  }

  var initDone = false;

  function init() {
    if (initDone) return;
    bar = document.querySelector('.pdp-sticky-atb');
    if (!bar) return;

    form = document.querySelector('.product-detail form[action*="/cart/add"]') ||
      document.querySelector('.product-form form[action*="/cart/add"]');
    realBtn = document.querySelector('.product-detail .quantity-submit-row__submit button[type="submit"]') ||
      document.querySelector('.product-detail button[type="submit"][data-add-to-cart-text]');

    titleEl = bar.querySelector('.pdp-sticky-atb__sel') || bar.querySelector('.pdp-sticky-atb__title');
    priceEl = bar.querySelector('.pdp-sticky-atb__price');
    barBtn = bar.querySelector('.pdp-sticky-atb__btn');

    if (!realBtn) {
      /* PHASE 3 FIX. This used to `return` outright, on the assumption that
         a missing submit button meant an unavailable product.

         MEASURED: on the fur PDP the button IS there — the diagnostic found
         it with these exact selectors — but not yet at DOMContentLoaded,
         because the app blocks in the buy area (Globo, the linked-options
         widget) re-render that row after the theme has painted. init() was
         therefore giving up on a page that was about to have a perfectly
         good button, and the sticky bar never showed however far you
         scrolled. The gallery still worked, which is what made this look
         like a styling problem rather than an initialisation one.

         So: wait for it, the same way initGallery waits for Slick. Give up
         quietly after ~15s, which is the genuinely-unavailable case. */
      if (initTries < 60) {
        initTries += 1;
        setTimeout(init, 250);
      }
      return;
    }

    /* Forward to the theme's own button rather than submitting the form
       ourselves: that preserves every app-bound click/submit handler,
       including the AJAX add-to-cart the drawer relies on. */
    initDone = true;   /* past the retry gate - wire everything once */

    if (barBtn) {
      barBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (barBtn.disabled) return;
        var sel = document.querySelector('.product-detail .option-selector .opt-btn:checked');
        var needsChoice = document.querySelector('.product-detail .option-selector') && !sel;
        if (needsChoice) {
          /* Send them to the selector instead of failing silently. */
          var target = document.querySelector('.product-detail .option-selectors');
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        realBtn.click();
      });
    }

    if ('IntersectionObserver' in window) {
      atbObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { atbOutOfView = !en.isIntersecting; });
        update();
      }, { rootMargin: '0px 0px -10px 0px', threshold: 0 });
      atbObserver.observe(realBtn);

      /* Never cover the footer. */
      var footer = document.querySelector('#pagefooter, .section-footer, footer');
      if (footer) {
        footObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { footerVisible = en.isIntersecting; });
          update();
        }, { threshold: 0 });
        footObserver.observe(footer);
      }
    } else {
      /* No IO (very old Safari): fall back to a scroll threshold. */
      window.addEventListener('scroll', function () {
        var r = realBtn.getBoundingClientRect();
        atbOutOfView = r.bottom < 0;
        update();
      }, { passive: true });
    }

    /* Variant changes rewrite price + button state. */
    /* Watch ONLY the price node and the real button, not the whole detail
       column — narrow targets plus idempotent writes keep this from
       re-entering itself. characterData is deliberately limited to the
       price subtree, which sync() never writes into. */
    if ('MutationObserver' in window) {
      var priceHost = document.querySelector('.product-detail .price-container') ||
        document.querySelector('.product-detail .price-area');
      if (priceHost) {
        new MutationObserver(scheduleSync).observe(priceHost, { subtree: true, childList: true, characterData: true });
      }
      new MutationObserver(scheduleSync).observe(realBtn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });

      /* Body class flips when the drawer/modal opens or closes. update()
         also writes a body class, hence the guard inside it. */
      new MutationObserver(update).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }

    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.product-detail')) scheduleSync();
    });

    /* PRE-LAUNCH PASS (8 Sept 2026) - keep the ONE pre-order rule true
       across variant changes. sections/main-product.liquid decides
       hl_is_preorder for the variant the page rendered with and writes
       the ids of every variant that satisfies the same rule (selling
       plan group + out of stock + continue selling) onto the form. When
       the shopper changes size, the class that hides the wallet button,
       the "or" rule and the next-day clock follows the selected variant,
       and the button label is re-resolved off the same list. */
    var pf = document.querySelector('.product-detail .product-form[data-hl-preorder-variants]');
    if (pf) {
      var preIds = (pf.getAttribute('data-hl-preorder-variants') || '').split(',').filter(Boolean);
      var preLabel = pf.getAttribute('data-hl-preorder-label') || 'Pre-order';
      var atcLabel = pf.getAttribute('data-hl-atc-label') || 'Add to Bag';
      var row = pf.querySelector('.quantity-submit-row');
      var applyPre = function () {
        var idEl = pf.querySelector('form[action*="/cart/add"] [name="id"]');
        if (!idEl || !row) return;
        var isPre = preIds.indexOf(String(idEl.value)) !== -1;
        if (row.classList.contains('hl-preorder-active') !== isPre) row.classList.toggle('hl-preorder-active', isPre);
        var cd = document.getElementById('shipping-countdown');
        if (cd) cd.classList.toggle('hl-preorder-hidden', isPre);
        if (realBtn && !realBtn.disabled) {
          var want = isPre ? preLabel : atcLabel;
          var cur = (realBtn.textContent || '').replace(/\s+/g, ' ').trim();
          /* Only rewrite the two labels this rule owns; leave "Sold out"
             and any app-owned text alone. */
          if (cur !== want && (cur === preLabel || cur === atcLabel || /add to bag|pre-?order/i.test(cur))) setText(realBtn, want);
        }
      };
      pf.addEventListener('change', function () { setTimeout(applyPre, 0); setTimeout(applyPre, 400); });
      if ('MutationObserver' in window) {
        var idNode = pf.querySelector('form[action*="/cart/add"] [name="id"]');
        if (idNode) new MutationObserver(function () { applyPre(); }).observe(idNode, { attributes: true, attributeFilter: ['value'] });
      }
      applyPre();
    }

    window.addEventListener('resize', update, { passive: true });

    sync();
    update();
  }

  /* ===================================================================
     EDITORIAL GALLERY — unslick at mobile widths.

     theme.js calls s.slick(r) unconditionally for the carousel-under /
     carousel-beside layouts (this store is carousel-under), and its own
     width branch only exists for the stacked layout — where it does the
     inverse of what we want. So we let the theme initialise, then destroy
     the carousel below 768 to leave a plain stacked scroll, and rebuild it
     if the viewport crosses back up (rotation).

     Variant image grouping still works: the theme marks off-colour slides
     with .slide--inactive-option, which is a class on the slide itself and
     survives unslicking. pdp.css hides those in the stacked view.
     =================================================================== */
  function galleryReady(cb, tries) {
    tries = tries || 0;
    var $ = window.jQuery;
    if ($ && $.fn && $.fn.slick) return cb($);
    if (tries > 60) return;              /* ~15s then give up quietly */
    setTimeout(function () { galleryReady(cb, tries + 1); }, 250);
  }

  function applyGalleryMode($) {
    var $g = $('.product-detail .product-slideshow');
    if (!$g.length) return;
    var mobile = isMobile();
    var isSlick = $g.hasClass('slick-initialized');

    if (mobile && isSlick) {
      try { $g.slick('slickUnfilter'); } catch (e) {}
      try { $g.slick('unslick'); } catch (e) {}
      $g.addClass('pdp-gallery--stacked');
    } else if (!mobile && !isSlick) {
      $g.removeClass('pdp-gallery--stacked');
      var opts = {};
      try { opts = JSON.parse($g.attr('data-slick') || '{}'); } catch (e) {}
      try { $g.slick(opts); } catch (e) {}
    }
  }

  function initGallery() {
    galleryReady(function ($) {
      applyGalleryMode($);
      /* The theme re-slicks on variant change for image grouping; re-assert
         after any such rebuild, and on rotation. */
      var t;
      var reassert = function () {
        clearTimeout(t);
        t = setTimeout(function () { applyGalleryMode($); }, 120);
      };
      $(window).on('resize.pdpGallery orientationchange.pdpGallery', reassert);
      document.addEventListener('change', function (e) {
        if (e.target && e.target.closest && e.target.closest('.product-detail .option-selectors')) reassert();
      });
      /* Theme init can land after us on slow app-heavy loads. */
      setTimeout(function () { applyGalleryMode($); }, 1200);
      setTimeout(function () { applyGalleryMode($); }, 3000);
    });
  }

  /* ===================================================================
     PHASE 3 — GALLERY CHROME (index counter + pill dots)

     On mobile the unslicked track is a native horizontal scroll-snap
     carousel (assets/pdp.css section 7.1). Nothing else knows which slide
     is showing, so read it off scrollLeft and write the counter and the
     active dot. Native scroll means no library and no rAF loop — one
     passive scroll listener, coalesced to a frame.

     Guarded so it is inert on desktop, where Slick is still in charge and
     draws its own dots.
     =================================================================== */
  function initGalleryChrome() {
    var track = document.querySelector('.product-detail .product-slideshow');
    if (!track) return;
    var idxCur = document.querySelector('[data-hl-gal-cur]');
    var dots = document.querySelectorAll('.pdp-fallback-dot');
    if (!idxCur && !dots.length) return;

    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var last = -1;

    function paint() {
      if (!isMobile()) return;
      var slides = track.querySelectorAll('.slide:not(.slide--inactive-option)');
      if (!slides.length) return;
      /* Which slide's left edge is nearest the track's scroll position. */
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (i < 0) i = 0;
      if (i > slides.length - 1) i = slides.length - 1;
      if (i === last) return;
      last = i;
      if (idxCur) setText(idxCur, pad(i + 1));
      for (var d = 0; d < dots.length; d++) {
        var on = d === i;
        if (dots[d].classList.contains('pdp-fallback-dot--active') !== on) {
          dots[d].classList.toggle('pdp-fallback-dot--active', on);
        }
      }
    }

    var pending = false;
    track.addEventListener('scroll', function () {
      if (pending) return;
      pending = true;
      (window.requestAnimationFrame || window.setTimeout)(function () {
        pending = false;
        paint();
      }, 16);
    }, { passive: true });

    /* Tapping a dot scrolls the track to that slide. */
    for (var k = 0; k < dots.length; k++) {
      (function (dot) {
        dot.addEventListener('click', function () {
          if (!isMobile()) return;
          var n = parseInt(dot.getAttribute('data-slide-index'), 10);
          if (isNaN(n)) return;
          track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
        });
      })(dots[k]);
    }

    window.addEventListener('resize', function () { last = -1; paint(); }, { passive: true });
    /* The track only becomes a snap carousel once pdp.js has unslicked, so
       repaint after the same beats initGallery() re-asserts on. */
    setTimeout(paint, 400);
    setTimeout(paint, 1400);
    setTimeout(paint, 3200);
  }

  function boot() {
    init();
    initGallery();
    initGalleryChrome();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
